var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Pattern"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.2875 20.7125V19.4L19.3875 3.2875H20.725V4.6L4.6 20.7125H3.2875ZM3.25 14.55V11.9125L11.9125 3.25H14.55L3.25 14.55ZM3.25 7.0125V3.25H7.0125L3.25 7.0125ZM16.9875 20.75L20.75 16.9875V20.75H16.9875ZM9.45 20.75L20.75 9.45V12.0875L12.0875 20.75H9.45Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPattern);
export default __webpack_public_path__ + "static/media/icon-pattern.cb067b466994c89518da696354a983ee.svg";
export { ForwardRef as ReactComponent };